import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledBox = styled.div`
  position: relative;
  width: ${rem('136px')};
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  z-index: 2;
  right: 0;
  width: ${rem('21px')};
  cursor: pointer;
`;

const StyledList = styled.ul`
  box-shadow: -2px 2px 2px 0 rgba(25, 25, 25, 0.15);
  background-color: ${props => props.theme.colors.dark};
  margin-bottom: 0;
  margin-top: 0;
  padding-left: 0;
  padding-top: 0;
  position: absolute;
  right: ${rem('-15px')};
  width: ${rem('252px')};
  z-index: 1;
  visibility: hidden;
  opacity: 0;
  transition: all 0.08s ease-in-out;
  ${props =>
    props.show &&
    css`
      opacity: 1;
      visibility: visible;
    `};
  top: ${rem('64px')};
  button {
    border: 0;
    background-color: transparent;
    color: ${props => props.theme.colors.light};
    list-style: none;
    cursor: pointer;
    margin-bottom: ${rem('12px')};
    font-size: ${props => props.theme.fontSize.small};
    font-family: ${props => props.theme.fonts.medium};
    &:hover {
      color: ${props => props.theme.colors[props.type]};
    }
  }
`;

// Elementos del listado
const StyledElement = styled.li`
  list-style: none;
  padding-left: 0;
  &:before {
    content: none;
  }
`;

// Enlaces
const StyledLink = styled.span`
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.light};
  display: flex;
  height: ${rem('50px')};
  font-family: ${props => props.theme.fonts.medium};
  font-size: 1rem;
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('43px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left: ${rem('70px')};
    &:hover {
      background-color:${props => props.theme.colors.grayDarkest};
      border-right:${rem('4px')} solid ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.primary};
    }
  `};
`;

const StyledOuterLink = styled.a`
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.colors.light};
  display: flex;
  height: ${rem('50px')};
  font-family: ${props => props.theme.fonts.medium};
  font-size: 1rem;
  width: 100%;
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('43px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left: ${rem('70px')};
    &:hover {
      background-color:${props => props.theme.colors.grayDarkest};
      border-right:${rem('4px')} solid ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.primary};
    }
  `};
`;

// Icono Logout
export const StyledIconLogout = styled(Icon)`
  fill: ${props => props.theme.colors.primary};
  height: ${rem('18px')};
  margin-right: ${rem('10px')};
  width: ${rem('18px')};
  ${mediaqueries.lessThan('mobile')`
    left: ${rem('22px')};
    top: ${rem('20px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    fill: ${props => props.theme.colors.light};
  `};
`;

// Logout
const StyledLogout = StyledLink.extend`
  background-color: ${props => props.theme.colors.grayDarkest};
  justify-content: center;
  &:hover {
    color: ${props => props.theme.colors.primary};
    ${StyledIconLogout} {
      fill: ${props => props.theme.colors.primary};
    }
  }
  ${mediaqueries.greaterThan('desktop')`
    background-color:inherit;
    justify-content:inherit;
  `};
`;

export {
  StyledBox,
  StyledList,
  StyledIcon,
  StyledElement,
  StyledLink,
  StyledOuterLink,
  StyledLogout
};
